document.addEventListener('alpine:init', () => {
  Alpine.data('newsArchive', () => ({
    activeFilter: 'all',
    search: '',

    setFilter(slug) {
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          this.activeFilter = slug;
        });
      } else {
        this.activeFilter = slug;
      }
    },

    isVisible(el) {
      const categories = el.dataset.categories ? el.dataset.categories.split(',') : [];
      const title = el.dataset.title || '';

      if (this.activeFilter !== 'all') {
        if (!categories.includes(this.activeFilter)) return false;
      }

      if (this.search.trim()) {
        if (!title.toLowerCase().includes(this.search.toLowerCase())) return false;
      }

      return true;
    },
  }));
});
